import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentGcseTab } from '@features/student-page/components/StudentGcseTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { requireRouteAudience } from '@services/router/routeAccess'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/gcse')({
  beforeLoad: requireRouteAudience(['staff']),
  component: RouteComponent,
  staticData: {
    crumb: {
      label: 'GCSE',
    },
  },
})

function RouteComponent() {
  const { studentNo } = Route.useParams()

  return (
    <QueryErrorBoundary title='Failed to load GCSE results'>
      <Suspense fallback={<LoadingIndicator resource='GCSE results' />}>
        <StudentGcseTab studentNo={studentNo} />
      </Suspense>
    </QueryErrorBoundary>
  )
}
